import React, { useState, useCallback } from 'react';
import { checkSubscription } from '../services/api';

const SubscriptionManager = () => {
  const [email, setEmail] = useState('');
  const [result, setResult] = useState(null);
  const [activationLinks, setActivationLinks] = useState({ singbox: '', clash: '' });
  const [copiedStates, setCopiedStates] = useState({ singbox: false, clash: false });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isExpired, setIsExpired] = useState(false);
  const [showAnnouncement, setShowAnnouncement] = useState(false);

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(String(email).toLowerCase());
  };

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setError('');
    setResult(null);
    setActivationLinks({ singbox: '', clash: '' });
    setCopiedStates({ singbox: false, clash: false });
    setIsExpired(false);
    if (!validateEmail(email)) {
      setError('请输入有效的邮箱地址');
      return;
    }
    setIsLoading(true);
    try {
      const subscriptionInfo = await checkSubscription(email);
      if (subscriptionInfo) {
        setResult(`订阅到期时间: ${subscriptionInfo.expirationDate}`);
        setIsExpired(!subscriptionInfo.isActive);
        if (subscriptionInfo.activationLinks) {
          setActivationLinks({
            singbox: subscriptionInfo.activationLinks.singbox || '',
            clash: subscriptionInfo.activationLinks.clash || ''
          });
        }
      } else {
        setResult('未找到该邮箱的订阅信息');
      }
    } catch (error) {
      setError('查询出错，请稍后再试');
      console.error('Error:', error);
    } finally {
      setIsLoading(false);
    }
  }, [email]);

  const handleShadowrocketImport = () => {
    window.location.href = "shadowrocket://add/sub://aHR0cHM6Ly9zdWIuY3VjbG91ZC50b3AvYXBpL3YxL2NsaWVudC9zdWJzY3JpYmU_dG9rZW49N2Y0OTA1YzViZTI5YjkxMzE4MDgzYWY0YjJlZGMxYTk?remark=%E9%BA%A6%E9%97%A8%E5%95%86%E5%BA%97";
  };
  const handleClashImport = () => {
    window.location.href = `clash://install-config?url=${activationLinks.clash}&name=%E9%BA%A6%E9%97%A8%E5%95%86%E5%BA%97`;
  };
  const copyLink = useCallback((platform) => {
    navigator.clipboard.writeText(activationLinks[platform]).then(
      () => {
        setCopiedStates(prev => ({ ...prev, [platform]: true }));
        setTimeout(() => setCopiedStates(prev => ({ ...prev, [platform]: false })), 3000);
      },
      () => setError('复制失败，请手动复制')
    );
  }, [activationLinks]);

  const handleRenewSubscription = useCallback(() => {
    // 这里替换为实际的订阅续费链接
    window.location.href = 'https://ouvg.top/buy/45';
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-2xl font-bold text-center mb-4">麦门订阅查询</h2>
      <div className="flex justify-between items-center mb-6">
          <a 
            href="https://ouvg.top/buy/45" 
            target="_blank" 
            rel="noopener noreferrer"
            className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded-full transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-110"
          >
            官网购买订阅
          </a>
          <button
            onClick={() => setShowAnnouncement(true)}
            className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded-full transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-110"
          >
            公告
          </button>
          <a 
            href="https://air.185101.xyz/clash/phone/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-full transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-110"
          >
            使用教程
          </a>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              邮箱查询
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder='请输入邮箱'
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
          </div>
          <button
            type="submit"
            disabled={isLoading || !email}
            className={`w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${
              isLoading || !email ? 'bg-indigo-400 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700'
            } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}
          >
            {isLoading ? '查询中...' : '查询'}
          </button>
        </form>
        {error && <p className="mt-4 text-center text-red-500">{error}</p>}
        {result && (
  <div className="mt-4">
    <p className="text-center">{result}</p>
    {isExpired && (
      <p className="text-center text-red-500 mt-2">订阅已过期</p>
    )}
  </div>
)}
        {/* 只在未过期且有激活链接时显示复制按钮 */}
{!isExpired && (activationLinks.singbox || activationLinks.clash) && (
  <div className="mt-4 grid grid-cols-2 gap-4">
    <div className="flex space-x-4">
      {activationLinks.singbox && (
        <button
          onClick={() => copyLink('singbox')}
          disabled={copiedStates.singbox}
          className={`flex-1 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${
            copiedStates.singbox ? 'bg-gray-400' : 'bg-green-600 hover:bg-green-700'
          } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500`}
        >
          {copiedStates.singbox ? '已复制' : '复制安卓订阅链接'}
        </button>
      )}
      </div>
      <div className="flex space-x-4">
      {activationLinks.clash && (
        <button
          onClick={() => copyLink('clash')}
          disabled={copiedStates.clash}
          className={`flex-1 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${
            copiedStates.clash ? 'bg-gray-400' : 'bg-blue-600 hover:bg-blue-700'
          } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`}
        >
          {copiedStates.clash ? '已复制' : '复制苹果订阅链接'}
        </button>
      )}
      </div>

      {activationLinks.clash && (
        <button
        onClick={handleShadowrocketImport}
        className="flex-1 min-w-[160px] flex flex-col py-2 px-4 border border-transparent rounded-md shadow-sm text-xs font-medium text-white bg-orange-600 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
      >
        <span>一键导入小火箭</span>
        <span className="text-[10px] font-normal mt-1">在Safari浏览器打开</span>
      </button>)}
      {activationLinks.clash && (
        <button
        onClick={handleClashImport}
        className="flex-1 min-w-[160px] py-2 px-4 border border-transparent rounded-md shadow-sm text-xs font-medium text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
      >
        <span>一键导入安卓Clash</span>
      </button>)}
      {activationLinks.clash && (
        <button
        onClick={handleClashImport}
        className="flex-1 min-w-[160px] py-2 px-4 border border-transparent rounded-md shadow-sm text-xs font-medium text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
      >
        <span>一键导入Windows-Clash</span>
      </button>)}
      {activationLinks.clash && (
        <button
        onClick={handleClashImport}
        className="flex-1 min-w-[160px] py-2 px-4 border border-transparent rounded-md shadow-sm text-xs font-medium text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
      >
        <span>一键导入MAC-ClashX</span>
      </button>)}
    </div>
)}
        {/* 在订阅过期时显示续订按钮 */}
{isExpired && (
  <button
    onClick={handleRenewSubscription}
    className="mt-4 w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-yellow-600 hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
  >
    续订订阅
  </button>
)}
      </div>
      <div className="mt-6 w-full max-w-md bg-gray-50 border border-gray-200 rounded-md p-4 shadow-sm">
        <h3 className="text-sm font-medium text-gray-700 mb-2">实用链接</h3>
        <div className="flex flex-wrap gap-4">
        <a 
            href="https://air.185101.xyz/clash/phone/" 
            target="_blank"
            rel="noopener noreferrer" 
            className="text-indigo-600 hover:text-indigo-800 text-sm font-medium"
          >
            使用教程
          </a>
          <a 
            href="https://pan.185101.xyz" 
            target="_blank"
            rel="noopener noreferrer" 
            className="text-indigo-600 hover:text-indigo-800 text-sm font-medium"
          >
            麦麦超全网盘影视资源搜索站
          </a>
          <a 
            href="https://so.185101.xyz" 
            target="_blank"
            rel="noopener noreferrer" 
            className="text-indigo-600 hover:text-indigo-800 text-sm font-medium"
          >
            麦麦实用网址资源收集站
          </a>
        </div>
      </div>
      <div className="mt-6 w-full max-w-md bg-gray-50 border border-gray-200 rounded-md p-4 shadow-sm">
        <h3 className="text-sm font-medium text-gray-700 mb-2">节点状态</h3>
        <div className="space-y-2">
        <div className="flex justify-between items-center">
            <span>订阅连接目前状态：</span>
            <span className="h-2 w-2 bg-green-500 rounded-full"></span>
          </div>
          <div className="flex justify-between items-center">
            <span>香港|三网优化线路|解锁</span>
            <span className="h-2 w-2 bg-green-500 rounded-full"></span>
          </div>
          <div className="flex justify-between items-center">
            <span>台湾|三网优化线路|解锁</span>
            <span className="h-2 w-2 bg-green-500 rounded-full"></span>
          </div>
          <div className="flex justify-between items-center">
            <span>日本|三网优化线路|解锁</span>
            <span className="h-2 w-2 bg-green-500 rounded-full"></span>
          </div>
          <div className="flex justify-between items-center">
            <span>新加坡|三网优化线路|解锁</span>
            <span className="h-2 w-2 bg-green-500 rounded-full"></span>
          </div>
          <div className="flex justify-between items-center">
            <span>韩国|三网优化线路|解锁</span>
            <span className="h-2 w-2 bg-green-500 rounded-full"></span>
          </div>
          <div className="flex justify-between items-center">
            <span>美国|三网优化线路|解锁</span>
            <span className="h-2 w-2 bg-green-500 rounded-full"></span>
          </div>

        </div>
      </div>
      {showAnnouncement && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full" id="my-modal">
          <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
            <div className="mt-3 text-center">
              <h3 className="text-lg leading-6 font-medium text-gray-900">公告</h3>
              <div className="mt-2 px-7 py-3">
                <p className="text-sm text-gray-500">
                2025-元旦:祝大家新的一年里，万事顺利，身体健康！
                </p>
              </div>
              <div className="items-center px-4 py-3">
                <button
                  id="ok-btn"
                  className="px-4 py-2 bg-blue-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-300"
                  onClick={() => setShowAnnouncement(false)}
                >
                  关闭
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubscriptionManager;
